
<div class="Section SolutionSection" id="solution">
    <div class="SectionContainer">
        <div class="SectionHeader">
            <div class="HeaderBadge">Unsere Lösung</div>
            <h2 class="SectionTitle">
                <span class="TitleAccent">Entdecken Sie TaxiFusion</span>
                Optimiert für Taxi- und Mietwagenunternehmer
            </h2>
            <div class="SuccessBar">
                <i class="ri-check-line"></i>
                <p>
                    Mit TaxiFusion sparen Sie Zeit, reduzieren Kosten und bleiben gesetzlich
                    konform
                </p>
            </div>
        </div>

        <div class="SolutionGrid">
            <div class="SolutionCard">
                <div class="SolutionTag">Lösung #1</div>
                <div class="CardIcon">
                    <i class="ri-shield-check-line" style="font-size: 24px"></i>
                </div>
                <div class="CardContent">
                    <h3>Gesetzeskonform</h3>
                    <div class="SolutionImpact">
                        <i class="ri-shield-check-line"></i>
                        <span>100% rechtlich abgesichert</span>
                    </div>
                    <p>
                        Stets aktuell mit TSE-Anforderungen – ohne zusätzlichen Aufwand für Sie.
                    </p>
                </div>
            </div>
            <div class="SolutionCard">
                <div class="SolutionTag">Lösung #2</div>
                <div class="CardIcon">
                    <i class="ri-dashboard-line" style="font-size: 24px"></i>
                </div>
                <div class="CardContent">
                    <h3>Einfache Verwaltung</h3>
                    <div class="SolutionImpact">
                        <i class="ri-timer-line"></i>
                        <span>15+ Stunden/Woche gespart</span>
                    </div>
                    <p>
                        Intuitive Software, die Ihre Verwaltungsaufgaben vereinfacht und
                        automatisiert.
                    </p>
                </div>
            </div>

            <div class="SolutionCard">
                <div class="SolutionTag">Lösung #3</div>
                <div class="CardIcon">
                    <i class="ri-money-euro-circle-line" style="font-size: 24px"></i>
                </div>
                <div class="CardContent">
                    <h3>Erinnerungen</h3>
                    <div class="SolutionImpact">
                        <i class="ri-money-euro-circle-line"></i>
                        <span>Bis zu 2.500€ gespart/Jahr</span>
                    </div>
                    <p>
                        Intelligente Benachrichtigungen für P-Scheine, TÜV und mehr sichern Ihre
                        Einnahmen.
                    </p>
                </div>
            </div>
        </div>

        <!-- Transformed to a CTA card -->
        <div class="SolutionCTACard">
            <div class="CTACardContent">
                <div class="CTACardHeader">
                    <div class="CTAIcon">
                        <i class="ri-rocket-line"></i>
                    </div>
                    <h3>Starten Sie Ihr effizienteres Taxi- und Mietwagenunternehmen</h3>
                </div>

                <div class="CTACardBody">
                    <p>
                        <span class="Highlight">TaxiFusion</span> ist mehr als nur eine
                        TSE-Datenspeicherungslösung. Unser Ziel ist es, Ihnen die Werkzeuge an
                        die Hand zu geben, die Sie benötigen, um Ihr Geschäft effizienter und
                        rentabler zu gestalten.
                    </p>
                    <router-link to="/register">
                        <Button size="large">
                            Jetzt Registrieren <i class="ri-arrow-right-line"></i>
                        </Button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</div>
